import React from "react";
import useAxios, { configure } from "axios-hooks";
import Axios from "axios";
import randomizeArray from "../../helpers/randomizeArray";
import LOCAL_TEST_DATA from "../../data/data.js";

// Custom Axios configuration
const axios = Axios.create({
  baseURL: "//data.backyourlocal.com.au/json/",
  headers: {
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  },
  responseType: "json",
  transformResponse: [
    function (data) {
      return randomizeArray(data);
    },
  ],
});

// Apply configuration to all useAxios instances
configure({ axios });

const DataFetching = ({ children }) => {
  const [{ data, loading, error }] = useAxios("data.json");

  if (typeof children === "function") {
    return children({
      bizData: error ? LOCAL_TEST_DATA : data,
      isFetching: loading,
    });
  }

  return <>{children}</>;
};

export default DataFetching;
